import { render, staticRenderFns } from "./CropImg.html?vue&type=template&id=8b33f9d4&scoped=true&"
import script from "./CropImg.js?vue&type=script&lang=js&"
export * from "./CropImg.js?vue&type=script&lang=js&"
import style0 from "./CropImg.scss?vue&type=style&index=0&id=8b33f9d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b33f9d4",
  null
  
)

export default component.exports